
import { StateCreator } from "zustand";
import { SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY, AUTH_HEADER } from "../../../base";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import Endpoints from "../../../domain/endpoints";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchUserTerritoryBricksType } from "../../../domain/models/monthly-tour-program/fetch-user-territory-bricks";
import { FetchUserTerritoryBricks } from "../../../domain/useages/monthly-tour-program/fetchUserTerritoryBricks";
import { RemoteFetchUserTerritoryBricks } from "../../../data/usecases/monthly-tour-program/remote-fetch-user-territory-bricks";

export interface FetchUserTerritoryBricksInterface {
  FetchUserTerritoryBricks: FetchUserTerritoryBricksType;
  FetchUserTerritoryBricksState: FetchState;
  fetchUserTerritoryBricks: Function;
}

const initialStates = {
  FetchUserTerritoryBricks: {} as FetchUserTerritoryBricksType,
  FetchUserTerritoryBricksState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchUserTerritoryBricksSlice: StateCreator<
  FetchUserTerritoryBricksInterface
> = (set) => ({
  ...initialStates,
  fetchUserTerritoryBricks: async (filter: FetchUserTerritoryBricks.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchUserTerritoryBricks = new RemoteFetchUserTerritoryBricks(
      `${BASE_URL}${Endpoints.FETCH_USER_TERRITORY_BRICKS}`,
      axiosHttpClient
    );

    set(() => ({ FetchUserTerritoryBricksState: FetchState.LOADING }));
    let result = await remoteFetchUserTerritoryBricks.fetch(filter);
    return result;
  },
});
